export default "__VITE_ASSET__DH$ntuXY__"